// src/config/theme.js
// ─────────────────────────────────────────────────────────────────
// FONTE ÚNICA DE VERDADE para todos os valores visuais do jogo.
// Muda aqui → muda em todo o lado.
// O Tweaker (lil-gui) lê e escreve diretamente neste objeto em dev.
// ─────────────────────────────────────────────────────────────────

export const Theme = {

  // ── TILES ──────────────────────────────────────────────────────
  tile: {
    colorRed:    '#ef4444',
    colorYellow: '#e2ff68',
    colorGreen:  '#22c55e',
    colorBlue:   '#3b82f6',
    colorPurple: '#a855f7',
    strokeColor: '#0b0f14',
    strokeAlpha: 0.6,
    strokeWidth: 2,
  },

  // ── ANIMAÇÕES ──────────────────────────────────────────────────
  anim: {
    swapDuration:   105,   // ms — troca de tiles
    removeDuration: 120,   // ms — tiles a desaparecer
    fallDuration:   140,   // ms — tiles a cair
    spawnDuration:  160,   // ms — novos tiles a entrar
  },

  // ── HUD ────────────────────────────────────────────────────────
  hud: {
    panelColor:     '#0b1220',
    accentLine:     '#22d3ee',
    textTitle:      '#cbd5e1',
    textMain:       '#e2e8f0',
    textMuted:      '#94a3b8',
    textAccent:     '#a7f3d0',
    textStatus:     '#c7f9ff',
    goalBarColor:   '#22d3ee',   // fill colour for objective progress bar
    goalBarBgColor: '#1e293b',   // background of objective progress bar
    fontFamily:     'system-ui, Arial', // all HUD text — live-swappable via tweaker
  },

  // ── MONSTER BAR ────────────────────────────────────────────────
  monsterBar: {
    barColorLow:   '#22c55e',   // 0 – 49%
    barColorMid:   '#fde68a',   // 50 – 99%
    barColorReady: '#ff00ff',   // 100% — ready!
    pulseDuration: 250,         // ms do ciclo de pulsar
    pulseAlphaMin: 0.6,         // alpha mínimo no pulso
    readyScale:    1.05,        // escala da barra quando ready
  },

  // ── VFX ────────────────────────────────────────────────────────
  vfx: {
    // partículas de match
    matchParticleColor:    '#ffffff',
    matchParticleSize:     4,
    matchParticleDuration: 400,

    // texto de combo — fallback (usado se nenhum comboLevel fizer match)
    comboTextColor:  '#ffffff',
    comboTextStroke: '#000000',
    comboDuration:   1750,  // +25% (era 1400)
    comboCap:        10,    // multiplicador máximo (era 4)

    // ── Estilos por nível de multiplicador ─────────────────────────
    // O nível ativo é o de minMultiplier mais alto que seja ≤ ao combo atual.
    // useThemeColor: true  → usa a cor primária da região (passada pelo caller)
    // useThemeColor: false → usa o campo `color`
    // sound: null → silêncio  |  sound: 'nome_sfx' → toca quando o audio estiver ligado
    comboLevels: [
      {
        minMultiplier:   2,
        font:            'Kamikaze',
        fontSize:        '30px',
        color:           '#facc15',   // amarelo
        useThemeColor:   false,
        strokeColor:     '#000000',
        strokeThickness: 4,
        sound:           null,   // voz japonesa "duplo" — desativada
      },
      {
        minMultiplier:   3,
        font:            'Kamikaze',
        fontSize:        '36px',
        color:           '#fb923c',   // laranja
        useThemeColor:   false,
        strokeColor:     '#000000',
        strokeThickness: 5,
        sound:           null,   // voz japonesa "triplo" — desativada
      },
      {
        minMultiplier:   5,
        font:            'Kamikaze',
        fontSize:        '46px',
        color:           '#ff4500',   // ignorado se useThemeColor: true
        useThemeColor:   true,        // usa a cor primária da região atual
        strokeColor:     '#0b0f14',
        strokeThickness: 6,
        sound:           null,   // voz japonesa "combo" — desativada
      },
    ],

    // skill burst
    skillBurstColor:    '#facc15',
    skillBurstDuration: 500,

    // fail effect
    failTextColor:  '#ff3b3b',
    failDuration:   1100,

    // score feedback (+pontos a voar)
    scoreFeedbackColor:  '#e2e8f0',
    scoreFeedbackStroke: '#0b0f14',
  },

  // ── SONS ───────────────────────────────────────────────────────
  // Coloca o nome do ficheiro (sem extensão) para cada evento.
  // Exemplo: match: 'match_sfx'  →  src/assets/audio/sfx/match_sfx.wav
  // Deixa "" para silêncio (null quebra o tweaker lil-gui).
  sounds: {
    match:      "",
    combo:      "",
    skillReady: "",
    skillFire:  "",
    skillFail:  "",
    levelWin:   "",
    levelFail:  "",
  },
};

// ── HELPERS ────────────────────────────────────────────────────────

/** Converte '#ef4444' → 0xef4444 (formato Phaser) */
export function cssToPhaser(hex) {
  return parseInt((hex || '#ffffff').replace('#', ''), 16);
}

/** Converte nome de cor do jogo → hex Phaser, usando o tema atual */
export function tileColorToHex(color) {
  const map = {
    red:    Theme.tile.colorRed,
    yellow: Theme.tile.colorYellow,
    green:  Theme.tile.colorGreen,
    blue:   Theme.tile.colorBlue,
    purple: Theme.tile.colorPurple,
  };
  return cssToPhaser(map[color] || '#ffffff');
}
